<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <div class="row custom-header">
        <div class="col-md-4">
          <h4 class="modal-title">{{ title }}</h4>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-2 custom-close">
          <button type="button" class="btn-close" @click="close"></button>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div v-if="isSaving" class="row custom-body-saving">
        <div class="text-center">
          <i class="fa fa-spinner fa-spin"></i
          ><span class="ml-2">saving ...</span>
        </div>
      </div>
      <div v-else class="row custom-body">
        <div v-if="isMultiple" class="row mb-2">
          <div class="col-md-12">
            <label class="form-label"
              >Establish a Cardio Zone Program for:</label
            >
            <auto-suggest
              v-model="selectedMembers"
              placeholder="add a client (type to search)"
              :minChars="2"
              :delay="750"
              :searchable="true"
              :options="searchHandler"
              :object="true"
              :filterResults="false"
              :resolveOnLoad="false"
              mode="tags"
              @clear="validateMembers"
              @select="validateMembers"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-7">
            <cardio-goals
              ref="cardioGoals"
              class="custom-cardio"
              :zone="currentZone"
              :isEnabled="isZoneEnabled"
              :isMultiple="isMultiple"
              @save="confirmSaveZone"
            />
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-md-6">
                <span class="custom-span"
                  >selected week of: {{ selectedWeek }}</span
                >
              </div>
              <div class="col-md-6 text-end">
                <span v-if="!isMultiple" class="custom-span"
                  >program: {{ currentProgram }}</span
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-10">
                <z-calendar
                  ref="calendar"
                  v-model="date"
                  :config="config"
                  class="custom-calendar"
                  @selectedWeek="showWeek"
                />
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div>
        <!-- We won't need to show Heartrate History for Multiple Client Members -->
        <div v-if="!isMultiple" class="row">
          <div class="col-md-12 custom-history">
            <heartrate-history
              :currentProgram="currentProgram"
              @edit="editProgram"
              @remove="confirmRemoveZone"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
  <confirm
    :show="actionConfirm"
    :confirmTitle="confirmTitle"
    :confirmAction="confirmAction"
    :confirmQuestion="confirmQuestion"
    @closing="closeConfirmation"
    @proceed="performSaveZone"
  />
  <confirm-remove
    :show="actionConfirmRemove"
    :confirmTitle="confirmTitleRemove"
    :confirmAction="confirmActionRemove"
    :confirmQuestion="confirmQuestionRemove"
    @closing="closeModal"
    @proceed="performRemoveZone"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import globals from '@/Plugins/globals'
import CardioGoals from '@/Components/UserCardio/elements/cardio-goals'
import HeartrateHistory from '@/Components/UserCardio/elements/heartrate-history'
import Confirm from '@/Components/ZElements/ConfirmDialog'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
import ZCalendar from '@/Components/ZElements/Calendar.vue'
import ZDialog from '@/Components/ZElements/Dialog'
import ZSelect from '@/Components/ZElements/Select'
import AutoSuggest from '@vueform/multiselect'
export default {
  name: 'set-cardio-goals',
  components: {
    CardioGoals,
    ZCalendar,
    ZDialog,
    HeartrateHistory,
    Confirm,
    ConfirmRemove,
    ZSelect,
    AutoSuggest,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lgr',
      date: new Date(),
      config: {
        mode: 'range',
        rangeSeparator: ' - ',
        multipleSeparator: ', ',
        showYearArrows: false,
        format: 'MM/dd/yyyy',
        firstDayOfWeek: 1, // 1 = Sunday ... 7 = Monday
        weekDays: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        show: 'calendar', // input, inline, calendar
        isWeekSelect: true,
        type: this.viewType,
      },
      currentZone: {
        ids: '',
        startDate: '',
        totalMinutes: 0,
        belowMinutes: 0,
        inMinutes: 0,
        aboveMinutes: 0,
        belowPercent: 0,
        inPercent: 0,
        abovePercent: 0,
        belowRange: '',
        inRange: '',
        aboveRange: '',
        maxHR: 0,
      },
      selectedWeek: '',
      selectedMonday: null,
      currentProgram: '',
      currentProgramZone: null,
      isZoneEnabled: false,
      confirmTitle: 'Confirm Changes',
      confirmAction: 'Confirm',
      confirmQuestion: "Confirm you'd like to make these changes?",
      actionConfirm: null,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove:
        'Are you sure you wish to remove this Program Zone?',
      actionConfirmRemove: null,
      recipients: null,
      isSaving: false,
    }
  },
  emits: ['close', 'saved', 'changed'],
  mounted() {
    this.isSaving = false
    this.initGoals()
    if (this.member) {
      this.getProfile()
      this.currentZone.ids = this.member.id
    }
  },
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('usercardio', [
      'members',
      'member',
      'columns',
      'zoneProfile',
      'memberids',
    ]),
    isVisible() {
      return this.show !== null
    },
    selectedMembers: {
      get() {
        let _data = []
        this.memberids.forEach((element) => {
          let name = `${element.FirstName} ${element.LastName}`
          _data.push({
            id: element.user_id,
            value: name,
            label: name,
            firstname: element.FirstName,
            lastname: element.LastName,
          })
        })
        return _data
      },
      set(value) {
        console.log('Set Members', value)
        this.setChecked({
          action: 'all',
          checked: false,
        })
        if (value) {
          if (value.length > 0) {
            value.forEach((element) => {
              let data = {
                user_id: element.id,
                checked: true,
                FirstName: element.firstname,
                LastName: element.lastname,
              }
              this.setChecked({
                action: 'member',
                checked: data,
              })
            })
          }
        }
      },
    },
    isMultiple() {
      let _is = false
      if (this.show) {
        _is = this.show.isMultiple
        if (this.show.isMultiple) {
          this.initGoals()
        }
      }
      return _is
    },
    title() {
      let _title = 'Cardio Zone Program'
      return _title
    },
    viewType() {
      let _type = 'single'
      if (this.show) {
        if (this.show.isMultiple) {
          _type = 'multiple'
        }
      }
      return _type
    },
    // showSave() {
    //   let _show = true
    //   if (this.show) {
    //     if (this.show.isMultiple) {
    //       // TODO: validate members exists
    //       if (this.currentZone.totalMinutes === 0) {
    //         _show = false
    //       }
    //     }
    //   }
    //   return _show
    // },
    zones() {
      let _zones = []
      if (this.zoneProfile && !this.isMultiple) {
        _zones = this.zoneProfile.usercardioprograms
      }
      return _zones
    },
  },
  methods: {
    ...mapActions('users', ['findUsers']),
    ...mapActions('usercardio', [
      'setCustomView',
      'getZoneProfile',
      'saveCardioZone',
      'removeCardioZone',
      'setChecked',
    ]),
    close() {
      this.$emit('close')
    },
    async getProfile() {
      if (this.member) {
        let data = {
          ids: this.member.id,
          type: 'single',
        }
        await this.getZoneProfile(data)
      }
    },
    initGoals() {
      this.selectedWeek = ''
      this.selectedMonday = null
      this.currentProgram = ''
      this.currentProgramZone = null
      this.isZoneEnabled = false
      this.initZone()
    },
    initZone() {
      this.currentZone = {
        ids: '',
        startDate: moment().format('YYYY-MM-DD'),
        totalMinutes: 0,
        belowMinutes: 0,
        inMinutes: 0,
        aboveMinutes: 0,
        belowPercent: 0,
        inPercent: 0,
        abovePercent: 0,
        belowRange: '',
        inRange: '',
        aboveRange: '',
        maxHR: 0,
      }
    },
    async searchHandler(query) {
      let options = {
        term: query,
        orgId: this.show.orgid,
      }
      console.log('Searching for Members', options)
      return await this.findUsers(options)
    },
    setRecipients(value) {
      this.recipients = JSON.parse(JSON.stringify(value))
    },
    validateMembers() {
      let valid = true
      let whatsNot = ''
      // if (valid && this.recipients.length === 0) {
      //   valid = false
      //   whatsNot = 'recipients'
      // }
      // console.log('valid?', {
      //   isValid: valid,
      //   whatsNot: whatsNot,
      // })
      this.$emit('valid', valid)
    },
    closeModal() {
      this.actionConfirm = null
      this.actionConfirmRemove = null
    },
    closeConfirmation() {
      this.actionConfirm = null
      this.$refs.cardioGoals.cancelled()
    },
    setCurrentProgram(d) {
      this.currentProgram = ''
      let currentMonday = null
      for (var i = 0; i < this.zones.length; i++) {
        currentMonday = new Date(this.zones[i].StartDate)
        currentMonday.setHours(0, 0, 0, 0)
        if (d >= currentMonday) {
          break
        }
      }
      if (currentMonday === null) currentMonday = globals.getMonday(new Date())
      if (currentMonday !== null)
        this.currentProgram =
          currentMonday.getMonth() + 1 + '/' + currentMonday.getDate()
    },
    setZoneSettings(id) {
      this.initZone()
      // set the Zone from existing Program Zones
      let zone = this.zones.find((x) => x.id === id)
      if (zone) {
        this.currentZone.belowMinutes = parseFloat(zone.MinutesBelowZone)
        this.currentZone.inMinutes = parseFloat(zone.MinutesInZone)
        this.currentZone.aboveMinutes = parseFloat(zone.MinutesAboveZone)
        this.currentZone.totalMinutes =
          this.currentZone.belowMinutes +
          this.currentZone.inMinutes +
          this.currentZone.aboveMinutes
        if (this.currentZone.totalMinutes > 0) {
          this.currentZone.belowPercent = parseFloat(
            (this.currentZone.belowMinutes / this.currentZone.totalMinutes) *
              100
          )
          this.currentZone.inPercent = parseFloat(
            (this.currentZone.inMinutes / this.currentZone.totalMinutes) * 100
          )
          this.currentZone.abovePercent = parseFloat(
            (this.currentZone.aboveMinutes / this.currentZone.totalMinutes) *
              100
          )
        }
        this.currentZone.maxHR = zone.HRmax
        this.currentZone.belowRange = zone.BelowZoneRange
        this.currentZone.inRange = zone.InZoneRange
        this.currentZone.aboveRange = zone.AboveZoneRange

        this.currentZone.totalMinutes = this.currentZone.totalMinutes.toFixed(1)
        this.currentZone.belowMinutes = this.currentZone.belowMinutes.toFixed(1)
        this.currentZone.inMinutes = this.currentZone.inMinutes.toFixed(1)
        this.currentZone.aboveMinutes = this.currentZone.aboveMinutes.toFixed(1)
        this.currentZone.belowPercent = this.currentZone.belowPercent.toFixed(0)
        this.currentZone.inPercent = this.currentZone.inPercent.toFixed(0)
        this.currentZone.abovePercent = this.currentZone.abovePercent.toFixed(0)

        if (this.viewType === 'multiple') {
          // pull comma-delimited id list from selected Client List
          this.currentZone.ids = ''
        } else {
          // for a single Client Member, just their id
          this.currentZone.ids = this.member.id
        }
        if (this.selectedMonday === null) {
          this.selectedMonday = new Date()
        }
        this.currentZone.startDate = moment(this.selectedMonday).format(
          'YYYY-MM-DD'
        )
      }
    },
    isEditable(d) {
      let is = false
      if (d !== undefined && d !== null) {
        let today = new Date()
        let thisMonday = globals.getMonday(today)
        let firstMonday = new Date(thisMonday)
        firstMonday.setDate(firstMonday.getDate())
        let lastMonday = new Date(thisMonday)
        lastMonday.setDate(lastMonday.getDate() + 180)
        if (
          d.getTime() >= firstMonday.getTime() &&
          d.getTime() < lastMonday.getTime()
        ) {
          is = true
        }
      }
      return is
    },
    showWeek(week) {
      console.log('Show Week', week)
      this.isZoneEnabled = this.isEditable(week.monday)
      if (this.isMultiple) {
        // for Multiple, just grab the selected Monday
        this.currentZone.startDate = week.monday
        this.selectedMonday = week.monday
        this.selectedWeek = week.text
        // TODO: validate using the chosen member's ids
        // if (this.list === undefined || this.list === null) {
        //   this.isZoneEnabled = false
        // }
      } else {
        // for a Single, get the Zone from the Program Zone list
        let id = 0
        this.selectedMonday = week.monday
        this.selectedWeek = week.text
        let zoneStart = null
        let zoneEnd = null
        for (var i = 0; i < this.zones.length; i++) {
          zoneStart = new Date(this.zones[i].StartDate)
          zoneStart.setHours(0, 0, 0, 0)
          if (zoneEnd !== null) {
            if (
              week.monday.getTime() >= zoneStart.getTime() &&
              week.monday.getTime() <= zoneEnd.getTime()
            ) {
              id = this.zones[i].id
              break
            }
          }
          zoneEnd = new Date(zoneStart)
          zoneEnd.setDate(zoneEnd.getDate() - 1)
        }
        if (id === 0) {
          for (var j = this.zones.length - 1; j >= 0; j--) {
            zoneStart = new Date(this.zones[j].StartDate)
            zoneStart.setHours(0, 0, 0, 0)
            if (week.monday.getTime() >= zoneStart.getTime()) {
              id = this.zones[j].id
            }
          }
        }
        if (id > 0) {
          this.setCurrentProgram(zoneStart)
          this.setZoneSettings(id)
        }
      }
    },
    confirmSaveZone() {
      // User is saving, ask for confirmation
      if (this.isMultiple) {
        this.confirmQuestion = `These Zone Program settings will be effective on ${moment(
          this.currentZone.startDate
        ).format(
          'MM/DD/YYYY'
        )}.</br></br> Confirm you'd like to make these changes?`
      } else {
        this.confirmQuestion = `These Zone Program settings for ${
          this.member.firstName
        } ${this.member.lastName} will be effective on ${moment(
          this.currentZone.startDate
        ).format(
          'MM/DD/YYYY'
        )}.</br></br> Confirm you'd like to make these changes?`
      }
      this.actionConfirm = true
    },
    async performSaveZone() {
      // Save confirmed, proceed
      this.actionConfirm = null
      let ids = ''
      if (this.isMultiple) {
        ids = ''
        // TODO: gather up the selected member's ids
        console.log('Save Cardio: gather up ids', this.memberids)
        this.memberids.forEach((element) => {
          if (ids !== '') {
            ids += ','
          }
          ids += element.user_id
        })
      } else {
        ids = this.member.id
      }
      if (ids !== '') {
        this.isSaving = true
        try {
          let data = {
            ids: ids,
            edit: '0',
            StartDate: moment(this.currentZone.startDate).utc().format(),
            MinutesBelowZone: this.currentZone.belowMinutes,
            MinutesInZone: this.currentZone.inMinutes,
            MinutesAboveZone: this.currentZone.aboveMinutes,
            HRmax: this.currentZone.maxHR,
            type: this.viewType,
            returnPrograms: true,
          }
          console.log('Saving Zone', data)
          await this.saveCardioZone(data)
        } catch (e) {
          console.log('performSaveZone error:', e)
        }
        this.isSaving = false
        this.$emit('changed')
        if (this.isMultiple) {
          this.$emit('close')
        }
      }
    },
    editProgram(program) {
      this.$refs.calendar.selectDay({
        label: program.startDate.getDate(),
        date: program.startDate,
        isSelected: true,
      })
    },
    confirmRemoveZone(program) {
      // User is confirming the removal of a Zone
      this.currentProgramZone = program
      this.actionConfirmRemove = true
    },
    async performRemoveZone(program) {
      // Removal confirmed, proceed
      this.actionConfirmRemove = null
      let result = await this.removeCardioZone({
        id: this.currentProgramZone.id,
        userid: this.profile.id,
      })
      if (result.success) {
        this.currentProgram = ''
        this.$forceUpdate()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
  position: relative;
}
.custom-close {
  text-align: right;
  position: absolute;
  right: -20px;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-body-saving {
  height: 400px;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-cardio {
  padding: 5px;
}
.custom-calendar {
}
.custom-span {
  font-size: 0.8em;
}
.custom-history {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 400px;
}
.custom-action-button {
  color: #0d6efd;
}
.custom-action-button:focus {
  box-shadow: none !important;
}
.custom-actions {
  font-size: 1.5em;
}
</style>
